



















import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import AppRatingBar from '@/components/AppRatingBar.vue'
import AppTitleBar from '@/components/AppTitleBar.vue'
import ItemReviewList from '@/components/ItemReviewList.vue'
import { CURRENT_USER } from '@/gql/auth'
import { REVIEWABLE_ORDER_ITEM_IDS } from '@/gql/user'
import { Common } from '@/mixins'

@Component({
  components: {
    AppRatingBar,
    AppTitleBar,
    ItemReviewList
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    },
    item: {
      query: gql`query ($itemId: ID!) {
        item(itemId: $itemId) {
          id
          isActive
        }
      }`,
      variables () { return { itemId: this.$route.params.id } },
      async result ({ data }) {
        if (!data.item.isActive) {
          await this.routerReplace('/not-found')
        }
      }
    },
    itemReviewCount: {
      query: gql`query ($itemId: ID!) {
        itemReviewCount(filter: { itemId: $itemId })
      }`,
      variables () { return { itemId: this.$route.params.id } }
    },
    itemReviewRate: {
      query: gql`query ($itemId: ID!) {
        itemReviewRate(filter: { itemId: $itemId })
      }`,
      variables () { return { itemId: this.$route.params.id } }
    },
    reviewableOrderItems: {
      query: REVIEWABLE_ORDER_ITEM_IDS,
      variables () { return { itemId: this.$route.params.id } },
      skip () { return !this.currentUser }
    }
  }
})
export default class extends Mixins(Common) {
  reviewableOrderItems = []
}
